<template>
  <div class="full-screen-background">
  <v-container class="pa-4">
    <v-row>
      <v-col cols="12">
        <h2>{{ $t('inbox.title', { count: mails.length }) }}</h2>

        <v-alert v-if="!auth.token" type="warning" text>
          {{ $t('inbox.loginRequired') }}
        </v-alert>

        <v-list v-else two-line class="listOpacity">
          <template  v-for="mail in mails" :key="mail.id" >
            <v-list-item class="mb-4 pa-3 ">
              <v-list-item-content>
                <v-list-item-title class="d-flex align-center ">
                  <strong>{{ mail.title }}</strong>
                  <span class="grey--text text--darken-1 ml-2">
                    {{ $t('inbox.from', { sender: mail.senderName }) }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ mail.content }}
                </v-list-item-subtitle>
                <div class="mt-2 d-flex flex-wrap">
                  <v-chip small class="mr-2">
                    {{ $t('inbox.gold', { amount: mail.gold }) }}
                  </v-chip>
                  <v-chip small class="mr-2">
                    {{ $t('inbox.silver', { amount: mail.silver }) }}
                  </v-chip>
                  <v-chip small class="mr-2">
                    {{ $t('inbox.bronze', { amount: mail.bronze }) }}
                  </v-chip>
                  <v-chip small color="primary" text-color="white">
                    {{ $t('inbox.item', { name: getItemName(mail.itemId) }) }}
                  </v-chip>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { fetchMail } from '@/services/api.js'
import { auth } from '@/auth.js'

// parse do INI para nomes de item
function parseItemIni(text) {
  const map = {}
  const clean = text.replace(/\r/g, '')
  const entries = clean.split(/\n(?=\d+\|)/)
  entries.forEach(entry => {
    const parts = entry.split('|')
    const id   = parts[0]?.trim().replace(/^\uFEFF/, '')
    const name = parts[1]?.trim()
    if (id && name) map[id] = name
  })
  return map
}

const mails   = ref([])
const itemMap = ref({})

function getItemName(itemId) {
  return itemMap.value[String(itemId)] || `Item #${itemId}`
}

onMounted(async () => {
  if (!auth.token) return

  // Carrega INIs de nomes
  try {
    const base = process.env.BASE_URL || '/'
    for (const f of ['auxiliadores/T_Item.ini','auxiliadores/T_ItemMall.ini']) {
      const res = await fetch(`${base}${f}`)
      if (!res.ok) continue
      const txt = await res.text()
      Object.assign(itemMap.value, parseItemIni(txt))
    }
  } catch (e) {
    console.error('Erro ao carregar INIs:', e)
  }

  // Carrega mensagens
  try {
    const resp = await fetchMail(auth.token)
    mails.value = Array.isArray(resp.mails) ? resp.mails : []
  } catch (err) {
    console.error('Erro ao carregar mensagens:', err)
    mails.value = []
  }
})
</script>

<style scoped>
.listOpacity{
  /* uma sobreposição branca meio translúcida */
  background-color: rgba(0, 0, 0, 0.459);
  padding: 1rem;          /* opcional, para dar espaçamento interno */
  border-radius: 0.5rem;  /* opcional, só pra ficar mais bonito */
}
.full-screen-background {
  background-image: url('@/assets/background/fundotrocasenha.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}
h2 { margin: 0 0 1rem; }
</style>
